import { ColorSelectorGroup, ColorValue } from '@dreryk/react-components';

import { translationKeys } from '../../../../../translations';
import { CustomPatientGroupsFormController } from '../CustomPatientGroupsForm.types';

import { PRIMARY_COLOR_PALETTE } from './CustomPatientGroupsColor.constants';

const CUSTOM_PATIENT_GROUPS_COLOR_FIELD_NAME = 'primaryColor';

export type CustomPatientGroupsColorFormBeanPart = { [CUSTOM_PATIENT_GROUPS_COLOR_FIELD_NAME]: ColorValue };
type CustomPatientGroupsColorProps = Pick<CustomPatientGroupsFormController, 'register'>;

export const CustomPatientGroupsColor = (props: CustomPatientGroupsColorProps): JSX.Element => {
   return (
      <ColorSelectorGroup
         testId={CUSTOM_PATIENT_GROUPS_COLOR_FIELD_NAME}
         label={translationKeys.customGroupColor}
         controller={props.register(CUSTOM_PATIENT_GROUPS_COLOR_FIELD_NAME, {
            required: { value: true, message: translationKeys.selectColorFromProvided },
         })}
         required
      >
         {PRIMARY_COLOR_PALETTE.map((hexColor) => (
            <ColorSelectorGroup.HexColor key={hexColor} testId={hexColor} color={hexColor} />
         ))}
      </ColorSelectorGroup>
   );
};
